export default __webpack_public_path__ + "static/media/PlusJakartaSans-Bold.0e7c8235.woff2";